{
  "page": {
    "eyebrow": "モデレーション",
    "title": "管理ダッシュボード",
    "subtitle": "出品、注文、係争、ユーザー、プラットフォームの状態を確認します。",
    "loading": "読み込み中…"
  },
  "tabs": {
    "overview": "ダッシュボード",
    "users": "ユーザー",
    "sellers": "出品者",
    "sellersReview": "出品者審査",
    "auctions": "オークション",
    "orders": "注文",
    "payments": "支払い",
    "payouts": "支払送金",
    "shipments": "配送",
    "disputes": "係争",
    "reports": "通報",
    "settings": "設定",
    "reviews": "レビュー",
    "financial": "財務",
    "health": "システム状態",
    "webhooks": "Webhooks",
    "audit": "監査ログ",
    "promotions": "注目プロモ",
    "aiAnalytics": "AI 分析",
    "marketData": "market データ",
    "cron": "cron 状態",
    "push": "プッシュ状態",
    "cardMaster": "カードマスター",
    "emailCentre": "メールセンター",
    "advertising": "広告・パートナー",
    "homepageStats": "ホーム統計",
    "newsletter": "ニュースレター",
    "community": "コミュニティ",
    "events": "イベント",
    "articles": "記事",
    "dealers": "ディーラー",
    "sellerTrust": "出品者信頼度",
    "launch": "ローンチチェック",
    "stripe": "Stripe デバッグ"
  },
  "overview": {
    "title": "プラットフォーム概要",
    "subtitle": "BidNova Auctions 全体のアクティビティ概況。",
    "loading": "概要を読み込み中…",
    "error": "概要を読み込めませんでした。",
    "totalUsers": "総ユーザー数",
    "activeSellers": "アクティブ出品者",
    "approvedSellers": "承認済み出品者",
    "liveAuctions": "開催中オークション",
    "orders": "注文",
    "ordersLive": "進行中 {count} 件",
    "grossSales": "総売上",
    "pendingPayouts": "送金待ち",
    "shipments": "配送件数",
    "activeDisputes": "進行中の係争"
  }
}
